import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-end',
      flexDirection: 'row',
    },

    '& .MuiInputBase-root.Mui-disabled': {
      color: 'black',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: 'black',
    },
  },

  name: {
    marginTop: 10,

    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },
  },

  url: {
    flexGrow: 1,
    marginTop: 10,

    [theme.breakpoints.up('lg')]: {
      marginLeft: 10,
      width: 'auto',
    },
  },

  description: {
    marginTop: 10,
  },

  area: {
    marginTop: 10,

    [theme.breakpoints.up('lg')]: {
      flexShrink: 0,
      marginLeft: 10,
      width: '30%',
    },
  },
}));

export default useStyles;
